module.exports = __webpack_public_path__ + "static/cover_mobile-664d7bdf6e927c96f99ea97e05005f26.png";